import { render, staticRenderFns } from "./ListComponentV2.vue?vue&type=template&id=5c5cc728&scoped=true&"
import script from "./ListComponentV2.vue?vue&type=script&lang=ts&"
export * from "./ListComponentV2.vue?vue&type=script&lang=ts&"
import style0 from "./listComponentV2.scss?vue&type=style&index=0&id=5c5cc728&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5cc728",
  null
  
)

export default component.exports